"use client";

// packages/eden-card/src/index.jsx
import { forwardRef } from "react";
import styled from "styled-components";
import {
  backgroundColorLevelCurrent,
  borderColorTertiary,
  boxShadowRaised,
  boxShadowDetached,
  boxShadowOverlaid,
  boxShadowPoppedOut,
  borderRadius,
  backgroundColorLevel2,
  backgroundColorLevel3,
  backgroundColorLevel4,
  backgroundColorLevel5
} from "@churchofjesuschrist/eden-style-constants";
import { jsx } from "react/jsx-runtime";
var boxShadowsByDepth = {
  raised: boxShadowRaised,
  detached: boxShadowDetached,
  overlaid: boxShadowOverlaid,
  poppedOut: boxShadowPoppedOut
};
var ActualCard = styled.div`
  background-color: ${backgroundColorLevelCurrent};
  border: 1px solid ${borderColorTertiary};
  border-radius: ${borderRadius};
  box-shadow: ${({ $depth }) => boxShadowsByDepth[$depth]};

  /* As they get deeper, the level deepens, or gets higher as the visual case may be. */
  & {
    --background-color-level-current: ${backgroundColorLevel2};
    background: ${backgroundColorLevelCurrent};
  }
  & & {
    --background-color-level-current: ${backgroundColorLevel3};
  }
  & & & {
    --background-color-level-current: ${backgroundColorLevel4};
  }
  & & & & {
    --background-color-level-current: ${backgroundColorLevel5};
  }
`;
var CardComponent = ({ renderAs = "div", depth = "raised", ...props }, ref) => /* @__PURE__ */ jsx(ActualCard, { $depth: depth, ...props, as: renderAs, ref });
var Card = forwardRef(CardComponent);
Card.displayName = "Card";
export {
  Card
};
